import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useCallback, useEffect, useMemo, useState } from "react";
import { sortPartialDates } from "../../../utils/dateManager";
import { typeSafeObjectEntries } from "../../../utils/helpers";
import { sortAmbassadors } from "../../../utils/sorting";
import { useAmbassadors, useAmbassadorsRefresh, } from "../../../hooks/useAmbassadors";
import useChatCommand from "../../../hooks/useChatCommand";
import AmbassadorButton from "../../../components/AmbassadorButton";
import AmbassadorCard from "../../../components/AmbassadorCard";
import Overlay from "./Overlay";
export default function Ambassadors() {
    // Panel uses default settings (no SettingsProvider) — default sort method is "default"
    var settingsSort = "default";
    var rawAmbassadors = useAmbassadors();
    var refresh = useAmbassadorsRefresh();
    var ambassadors = useMemo(function () {
        return sortAmbassadors(typeSafeObjectEntries(rawAmbassadors !== null && rawAmbassadors !== void 0 ? rawAmbassadors : {}), settingsSort, sortPartialDates);
    }, [rawAmbassadors]);
    // Allow chat commands to select an ambassador, as well as the user
    var _a = useState(), ambassadorCard = _a[0], setAmbassadorCard = _a[1];
    useChatCommand(useCallback(function (command, args) {
        if (command === "refresh" &&
            args.length === 1 &&
            args[0] === "extension") {
            setTimeout(function () {
                refresh === null || refresh === void 0 ? void 0 : refresh();
            }, Math.floor(Math.random() * 120 * 1000));
            return;
        }
        if (Object.keys(rawAmbassadors !== null && rawAmbassadors !== void 0 ? rawAmbassadors : {}).includes(command) &&
            args.length === 0)
            setAmbassadorCard(command);
    }, [refresh, rawAmbassadors]));
    // Unselect ambassador card if ambassador is no longer available after refresh
    useEffect(function () {
        if (ambassadorCard && rawAmbassadors && !(rawAmbassadors === null || rawAmbassadors === void 0 ? void 0 : rawAmbassadors[ambassadorCard])) {
            setAmbassadorCard(undefined);
        }
    }, [ambassadorCard, rawAmbassadors]);
    return (_jsxs("main", { className: "relative scrollbar flex max-h-full flex-wrap justify-center gap-4 overflow-x-hidden overflow-y-auto px-2 pt-16 pb-4 scrollbar-thumb-alveus-green scrollbar-track-alveus-tan md:px-4", children: [_jsx("div", { className: "absolute inset-x-0 top-0 h-12 w-screen bg-alveus-green" }), ambassadors.map(function (_a) {
                var key = _a[0];
                return (_jsxs(Fragment, { children: [_jsx(Overlay, { show: ambassadorCard === key, onClose: function () { return setAmbassadorCard(undefined); }, children: _jsx(AmbassadorCard, { ambassador: key, onClose: function () { return setAmbassadorCard(undefined); }, disableCardEffects: true }) }), _jsx(AmbassadorButton, { ambassador: key, onClick: function () { return setAmbassadorCard(key); }, className: "w-32 max-w-full md:w-48" })] }, key));
            })] }));
}
